// API Endpoints
export const API_ENDPOINTS = {
  EMAIL_SENDER: "https://bellagioemailsender.vercel.app/api/subscribe",
  GENERAL_EMAIL: "https://bellagioemailsender.vercel.app/api/general",
};

export const adminEmailAddress = "admin@bellagio.com";
export const adminEmailName = "Bellagio Admin";
export const appName = "Bellagio App";
export const domainName = "bellagio.com";
export const appURL = "https://bellagio.elegho.app";
export const companyName = "Bellagio 3";
export const companyId = "7Dw6sBMQrHLSiHoirHdN";

export const unitNumberLabel = "Unit Number";
export const unitOwnerLabel = "Unit Owner";
export const residentLabel = "Resident";
export const unitLabel = "Unit";

export const phaseLabel = "Tower";
export const blockLabel = "Floor";
export const lotLabel = "Unit";
